import React from 'react'
import subMonths from 'date-fns/subMonths'
import { Container } from './styles'
import { CalendarFilter, MedicalEventTypeFilter, MedicalViewSelector } from '~/components/shared/medicalViews'
import { EMedicalViews, IFetchPregnancy, IHealthProcedures, IPregnancy } from '~/interfaces'
import { useMaternalInfantHealthProcedures, usePatient } from '~/context'
import { filterHealthProceduresTypesMaternalInfant } from '~/constants/healthProceduresTypes'
import { SearchHealthProcedure } from '~/components/healthProcedures/SearchHealthProcedure'
import { Inline } from '~/styles'
import { useMaternalInfantViewSettings, useFetchBirthPregnancy } from '~/hooks'

export const Header = (): JSX.Element => {
  // TODO: Retirar do <Header /> passar para o componente pai.
  const { patient } = usePatient()

  // TODO: Retirar alguns elementos do <Header /> passar para o componente pai.
  const {
    infantHealthProcedures,
    neonateHealthProcedures,
    gestationHealthProcedures,
    filterHealthProceduresByTerm,
    handleFilterHealthProceduresPerDate,
    handleFilterHealthProceduresPerType,
    updateSelectedTimeline,
    updateSelectedPregnancy,
    hasDateFiltersActive,
    dateFiltersActive,
    hasTypeFiltersActive,
    typeFiltersActive,
    updateSelectedBaby
  } = useMaternalInfantHealthProcedures()

  // TODO: Retirar do <Header /> passar para o componente pai.
  const { updateMaternalInfantViewSettings } = useMaternalInfantViewSettings()

  // TODO: Retirar do <Header /> passar para o componente pai.
  useFetchBirthPregnancy(
    { pathParam: { childId: patient.id } },
    {
      onSettled: data => {
        updateSelectedTimeline('baby')
        // TODO: criar um tipo específico para pregnancy-info e parar de utilizar selectedPregnancy
        updateSelectedPregnancy({ ...data } as IPregnancy)
        updateSelectedBaby(patient.id)

        updateMaternalInfantViewSettings({
          medicalRecord: patient.medicalRecord.toString(),
          selectedPregnancy: { ...data } as IPregnancy,
          selectedBaby: patient.id,
          selectedTimeline: 'pediatric'
        })
      },
      onError: error => {
        updateSelectedTimeline('baby')
        // TODO: criar uma instância do objeto pregnancy-info utilizando null object pattern.
        updateSelectedPregnancy({
          mother: {
            name: 'Informação não encontrada'
          },
          startDate: subMonths(new Date(patient.birthDate), 9).toISOString(),
          endDate: patient.birthDate
        } as unknown as IFetchPregnancy)
        updateSelectedBaby(patient.id)
      }
    }
  )

  const getPregnancyHealthProcedures = (): IHealthProcedures[] => {
    return [...(neonateHealthProcedures ?? []), ...(infantHealthProcedures ?? []), ...(gestationHealthProcedures ?? [])]
  }

  const parseOptionsToSearchProcedures = (): IHealthProcedures[] => {
    return getPregnancyHealthProcedures()
  }

  return (
    <Container>
      <Inline width="100%" spacing="0.5rem" justifyContent="flex-end">
        <MedicalViewSelector selectedMedicalView={EMedicalViews.MATERNAL_INFANT} isActive />

        <MedicalEventTypeFilter
          options={filterHealthProceduresTypesMaternalInfant}
          selected={typeFiltersActive}
          isActive={hasTypeFiltersActive}
          onChange={handleFilterHealthProceduresPerType}
        />

        <CalendarFilter
          dates={dateFiltersActive}
          isActive={hasDateFiltersActive}
          onChange={handleFilterHealthProceduresPerDate}
        />
      </Inline>

      <SearchHealthProcedure options={parseOptionsToSearchProcedures()} handleSearch={filterHealthProceduresByTerm} />
    </Container>
  )
}
